import { render, staticRenderFns } from "./SalesmanLogin.vue?vue&type=template&id=70207430&"
import script from "./SalesmanLogin.vue?vue&type=script&lang=js&"
export * from "./SalesmanLogin.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports